<template>
  <v-container fluid class="pa-4">
    <v-row>
      <v-col cols="12">
        <v-alert :value="alert" type="success">Başarıyla kaydedildi.</v-alert>
        
        <v-card>
          <v-card-title class="pb-2">
            <v-icon left>account_balance</v-icon>
            {{ isEditMode ? 'Banka Düzenle' : 'Yeni Banka Ekle' }}
          </v-card-title>
          
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="bank.tenantId"
                    :items="tenantOptions"
                    item-text="tenantName"
                    item-value="tenantId"
                    label="Tenant *"
                    outlined
                    dense
                    :rules="requiredRules"
                  ></v-select>
                </v-col>

                <v-col cols="12" md="6">
                  <v-select
                    v-model="bank.companyId"
                    :items="companyOptions"
                    item-text="name"
                    item-value="id"
                    label="Şirket *"
                    outlined
                    dense
                    :loading="companiesLoading"
                    :disabled="companiesLoading"
                    :rules="requiredRules"
                  ></v-select>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="bank.ibanIdentifier"
                    label="IBAN Belirteci (3 Harf) *"
                    outlined
                    dense
                    :rules="ibanRules"
                    counter="3"
                    maxlength="3"
                    type="text"
                    hint="IBAN'ın 7, 8 ve 9. harfleri (örn: AKB, GAR)"
                    persistent-hint
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="bank.bankName"
                    label="Banka Adı *"
                    outlined
                    dense
                    :rules="requiredRules"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-select
                    v-model="bank.accountPurityType"
                    :items="purityOptions"
                    label="Hesap Milyem Türü"
                    outlined
                    dense
                    clearable
                    hint="Bu banka hesabının milyem türünü seçiniz"
                    persistent-hint
                  ></v-select>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="bank.goldAmountInGrams"
                    label="Bankadaki Altın Miktarı (Gram)"
                    outlined
                    dense
                    type="number"
                    step="0.01"
                    min="0"
                    hint="Bankada bulunan altının gram cinsinden miktarı"
                    persistent-hint
                    clearable
                  >
                    <template v-slot:append>
                      <v-icon small>grain</v-icon>
                    </template>
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="bank.cashAmount"
                    label="Bankadaki Nakit Tutarı (TL)"
                    outlined
                    dense
                    type="number"
                    step="0.01"
                    min="0"
                    hint="Bankada bulunan nakit tutar (TL)"
                    persistent-hint
                    clearable
                  >
                    <template v-slot:append>
                      <v-icon small>payments</v-icon>
                    </template>
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-select
                    v-model="bank.status"
                    :items="statusOptions"
                    label="Durum *"
                    outlined
                    dense
                    :rules="requiredRules"
                  ></v-select>
                </v-col>

                <v-col cols="12" v-if="isEditMode" class="grey lighten-4 pa-3">
                  <v-row>
                    <v-col cols="6">
                      <div class="caption grey--text">Oluşturma Tarihi</div>
                      <div>{{ formatDate(bank.createdDate) }}</div>
                    </v-col>
                    <v-col cols="6">
                      <div class="caption grey--text">Güncelleme Tarihi</div>
                      <div>{{ formatDate(bank.updatedDate) }}</div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              
              <v-row class="mt-4">
                <v-col cols="12">
                  <v-btn
                    color="success"
                    @click="saveBank"
                    :loading="saving"
                    :disabled="!valid"
                    class="mr-2"
                  >
                    <v-icon left>save</v-icon>
                    Kaydet
                  </v-btn>
                  
                  <v-btn
                    color="grey"
                    text
                    @click="goBack"
                  >
                    <v-icon left>arrow_back</v-icon>
                    Geri Dön
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment';
import companiesApi from '@/api/companies';

export default {
  data() {
    return {
      valid: false,
      alert: false,
      saving: false,
      companiesLoading: false,
      companyOptions: [],
      tenantOptions: [
      { tenantId: 1, tenantName: "ALTINDAFIRSAT" },
      { tenantId: 2, tenantName: "E-ALTIN" }
    ],
      bank: {
        ibanIdentifier: '',
        bankName: '',
        accountPurityType: null,
        goldAmountInGrams: null,
        cashAmount: null,
        status: 'ACTIVE',
        tenantId: null,
        companyId: 1
      },
      purityOptions: [
        { text: '1000 Milyem', value: 1000 },
        { text: '995 Milyem', value: 995 },
        { text: '916 Milyem', value: 916 }
      ],
      statusOptions: [
        { text: 'Aktif', value: 'ACTIVE' },
        { text: 'Pasif', value: 'PASSIVE' }
      ],
      ibanRules: [
        v => !!v || 'IBAN Belirteci zorunludur',
        v => (v && v.length === 3) || 'IBAN Belirteci tam 3 harf olmalıdır',
        v => /^[0-9]{3}$/.test(v) || 'Sadece büyük harf kullanabilirsiniz'
      ],
      requiredRules: [
        v => !!v || 'Bu alan zorunludur'
      ]
    };
  },

  computed: {
    isEditMode() {
      return !!this.$route.params.id;
    }
  },

  methods: {
    async loadCompanies() {
      this.companiesLoading = true;
      try {
        const d = (await companiesApi.getCompanies()).data;
        this.companyOptions = Array.isArray(d) ? d : [];
      } catch (e) {
        this.companyOptions = [];
      } finally {
        this.companiesLoading = false;
      }
    },
    async saveBank() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (!this.bank.tenantId) {
        alert('Lütfen Tenant seçiniz!');
        return;
      }

      this.saving = true;
      
      try {
        const payload = Object.assign({}, this.bank, {
          cashAmount: this.bank.cashAmount === undefined ? null : this.bank.cashAmount
        });

        if (this.isEditMode) {
          await this.$store.dispatch('partnerBanks/putPartnerBank', payload);
        } else {
          await this.$store.dispatch('partnerBanks/postPartnerBank', payload);
        }
        
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
          this.$router.push('/admin/partner-banks');
        }, 1500);
        
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Kaydetme hatası:', error);
        alert('Kaydetme sırasında hata oluştu!');
      } finally {
        this.saving = false;
      }
    },

    goBack() {
      this.$router.push('/admin/partner-banks');
    },

    formatDate(date) {
      return date ? moment(date).format('DD.MM.YYYY HH:mm') : '-';
    }
  },

  async mounted() {
    await this.loadCompanies();
    if (this.isEditMode) {
      try {
        await this.$store.dispatch('partnerBanks/getPartnerBank', this.$route.params.id);
        this.bank = Object.assign({}, this.bank, this.$store.state.partnerBanks.partnerBank);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Banka yükleme hatası:', error);
        alert('Banka bilgileri yüklenirken hata oluştu!');
        this.goBack();
      }
    }
  }
};
</script>

<style scoped>
.v-card-title {
  background-color: #f5f5f5;
}
</style>